import * as types from './action-types';

import { defineAction } from 'store/common/action-helpers';

export const fetchAdvisory = {
  request: ({ prettyId, advisoryId }) =>
    defineAction(types.FETCH_ADVISORY.REQUEST, { prettyId, advisoryId }),
  start: ({ prettyId, advisoryId }) =>
    defineAction(types.FETCH_ADVISORY.START, { prettyId, advisoryId }),
  success: ({ prettyId, advisoryId }) =>
    defineAction(types.FETCH_ADVISORY.SUCCESS, { prettyId, advisoryId }),
  failure: ({ prettyId, advisoryId, error }) =>
    defineAction(types.FETCH_ADVISORY.FAILURE, {
      prettyId,
      advisoryId,
      error,
    }),
};

export const fetchUserAdvisories = {
  request: ({ userId }) => defineAction(types.FETCH_ADVISORIES_BY_USER_ID.REQUEST, { userId }),
  start: ({ userId }) => defineAction(types.FETCH_ADVISORIES_BY_USER_ID.START, { userId }),
  success: ({ advisories, userId }) =>
    defineAction(types.FETCH_ADVISORIES_BY_USER_ID.SUCCESS, { advisories, userId }),
  failure: ({ userId, error }) =>
    defineAction(types.FETCH_ADVISORIES_BY_USER_ID.FAILURE, { userId, error }),
};

export const pollCurrentUserAdvisory = {
  start: ({ prettyId, advisoryId }) =>
    defineAction(types.POLL_ADVISORY.START, { prettyId, advisoryId }),
  stop: ({ prettyId, advisoryId }) =>
    defineAction(types.POLL_ADVISORY.STOP, { prettyId, advisoryId }),
};

export const showAcceptAdvisoryInstuctions = ({ prettyId, advisoryId }) =>
  defineAction(types.SHOW_ACCEPT_ADVISORY_INSTRUCTIONS, { prettyId, advisoryId });

export const checkAcceptAdvisoryStatus = {
  request: ({ prettyId, advisoryId }) =>
    defineAction(types.CHECK_ACCEPT_ADVISORY_STATUS.REQUEST, { prettyId, advisoryId }),
  start: ({ prettyId, advisoryId }) =>
    defineAction(types.CHECK_ACCEPT_ADVISORY_STATUS.START, { prettyId, advisoryId }),
  success: ({ prettyId, advisoryId }) =>
    defineAction(types.CHECK_ACCEPT_ADVISORY_STATUS.SUCCESS, { prettyId, advisoryId }),
  failure: ({ error, prettyId, advisoryId }) =>
    defineAction(types.CHECK_ACCEPT_ADVISORY_STATUS.FAILURE, { prettyId, advisoryId, error }),
};

export const acceptAdvisory = {
  request: ({ advisoryId, txHash, form }) =>
    defineAction(types.ACCEPT_ADVISORY.REQUEST, { advisoryId, txHash }, { form }),
  start: ({ advisoryId, txHash }) =>
    defineAction(types.ACCEPT_ADVISORY.START, { advisoryId, txHash }),
  success: ({ advisoryId, txHash }) =>
    defineAction(types.ACCEPT_ADVISORY.SUCCESS, { advisoryId, txHash }),
  failure: ({ error, advisoryId, txHash }) =>
    defineAction(types.ACCEPT_ADVISORY.FAILURE, { advisoryId, txHash, error }),
};

export const rejectAdvisory = {
  request: ({ advisoryId }) => defineAction(types.REJECT_ADVISORY.REQUEST, { advisoryId }),
  start: ({ advisoryId }) => defineAction(types.REJECT_ADVISORY.START, { advisoryId }),
  success: ({ advisoryId }) => defineAction(types.REJECT_ADVISORY.SUCCESS, { advisoryId }),
  failure: ({ error, advisoryId }) =>
    defineAction(types.REJECT_ADVISORY.FAILURE, { advisoryId, error }),
};

export const showRevokeAdvisoryInstructions = ({ advisoryId }) =>
  defineAction(types.SHOW_REVOKE_ADVISORY_INSTRUCTIONS, { advisoryId });

export const revokeAdvisory = {
  request: ({ advisoryId, txHash, form }) =>
    defineAction(types.REVOKE_ADVISORY.REQUEST, { advisoryId, txHash }, { form }),
  start: ({ advisoryId, txHash }) =>
    defineAction(types.REVOKE_ADVISORY.START, { advisoryId, txHash }),
  success: ({ advisoryId, txHash }) =>
    defineAction(types.REVOKE_ADVISORY.SUCCESS, { advisoryId, txHash }),
  failure: ({ error, advisoryId, txHash }) =>
    defineAction(types.REVOKE_ADVISORY.FAILURE, { advisoryId, txHash, error }),
};

export const softAcceptAdvisory = {
  request: ({ advisoryId, companyPrettyId }) =>
    defineAction(types.SOFT_ACCEPT_ADVISORY.REQUEST, { advisoryId, companyPrettyId }),
  start: ({ advisoryId, companyPrettyId }) =>
    defineAction(types.SOFT_ACCEPT_ADVISORY.START, { advisoryId, companyPrettyId }),
  success: ({ advisoryId, softConnection }) =>
    defineAction(types.SOFT_ACCEPT_ADVISORY.SUCCESS, {
      advisoryId,
      softConnection,
    }),
  failure: ({ advisoryId, error }) =>
    defineAction(types.SOFT_ACCEPT_ADVISORY.FAILURE, { advisoryId, error }),
};

export const softRejectAdvisory = {
  request: ({ advisoryId, companyPrettyId }) =>
    defineAction(types.SOFT_REJECT_ADVISORY.REQUEST, { advisoryId, companyPrettyId }),
  start: ({ advisoryId, companyPrettyId }) =>
    defineAction(types.SOFT_REJECT_ADVISORY.START, { advisoryId, companyPrettyId }),
  success: ({ advisoryId, softConnection }) =>
    defineAction(types.SOFT_REJECT_ADVISORY.SUCCESS, {
      advisoryId,
      softConnection,
    }),
  failure: ({ advisoryId, error }) =>
    defineAction(types.SOFT_REJECT_ADVISORY.FAILURE, { advisoryId, error }),
};

export const softValidateAdvisoryUsingLinkedin = {
  request: ({ advisoryId, companyPrettyId, linkedIn }) =>
    defineAction(types.SOFT_VALIDATE_ADVISORY_USING_LINKEDIN.REQUEST, {
      advisoryId,
      companyPrettyId,
      linkedIn,
    }),
  start: ({ advisoryId, companyPrettyId, linkedIn }) =>
    defineAction(types.SOFT_VALIDATE_ADVISORY_USING_LINKEDIN.START, {
      advisoryId,
      companyPrettyId,
      linkedIn,
    }),
  success: ({ advisoryId, softConnection }) =>
    defineAction(types.SOFT_VALIDATE_ADVISORY_USING_LINKEDIN.SUCCESS, {
      advisoryId,
      softConnection,
    }),
  failure: ({ advisoryId, error }) =>
    defineAction(types.SOFT_VALIDATE_ADVISORY_USING_LINKEDIN.FAILURE, { advisoryId, error }),
};

export const modifySoftAdvisoryStatus = ({ advisoryId }) =>
  defineAction(types.MODIFY_SOFT_ADVISORY_STATUS, { advisoryId });



// WEBPACK FOOTER //
// ./src/store/features/users/advisories/actions.js